export default __webpack_public_path__ + "static/media/AURO-PRO-RENAL.a2b60dde.jpg";